import React from 'react'

import {Button, ctaVariants} from '@/components/ui/button'
import {buttonFunctions, appendSearchParams, CoreButtonProps} from './utils'
import {cn} from '@/lib/utils'
import type {VariantProps} from 'class-variance-authority'

// Get the variant type from the ctaVariants
type ButtonVariantProps = VariantProps<typeof ctaVariants>

export interface ButtonComponentProps extends CoreButtonProps {
    disabled?: boolean
    variant?: ButtonVariantProps['variant']
    isRevShare?: boolean
    className?: string
    [key: string]: any // For ...props
}

export const ButtonComponent = ({
    ctaType,
    disabled,
    variant,
    isRevShare,
    openInNewTab,
    children,
    clickFunction = buttonFunctions.linkToPage,
    scrollTargetId,
    routeType,
    url,
    queryParams,
    className,
    dataTestId,
    ...props
}: ButtonComponentProps) => {
    const hrefValue = appendSearchParams({
        url,
        queryParamData: queryParams,
        clickFunction,
        scrollTargetId
    })

    if (clickFunction === buttonFunctions.nothing || !hrefValue) {
        return (
            <Button
                className={cn(className, isRevShare && 'rev-share')}
                ctaType={ctaType}
                disabled={disabled}
                variant={variant}
                {...props}
                data-testid={dataTestId || 'button-Button'}
            >
                {children}
            </Button>
        )
    }

    const buttonProps = {
        className: cn(className, isRevShare && 'rev-share'),
        ctaType,
        disabled,
        variant,
        routeType,
        hrefValue,
        openInNewTab,
        asChild: true,
        ...props,
        'data-testid': dataTestId || 'button-Button'
    }

    return (
        <Button {...buttonProps} data-testid={dataTestId || 'button-Button'}>
            {children}
        </Button>
    )
}
